export const categoryVariables = {

    ct_name: '{{CATEGORY_NAME}}'

}

export const pageVariables = {

    page_name: '{{PAGE_TITLE}}'

}